// @flow

import * as React from "react"
import { A } from "../../../js/site/layout"
import { useStaticQuery, graphql, Link } from "gatsby"

import "isomorphic-fetch"

export default () => (
    <>
        <NewsletterSignup />
        <Tags />
        <Signup />
        <Social />
    </>
)

type NewsletterSignupState = {
    submitted: boolean,
    errors: ?string,
    fields: {
        email: string,
    },
}

class NewsletterSignup extends React.Component<*, NewsletterSignupState> {
    M: Object

    state = {
        submitted: false,
        errors: null,
        fields: { email: "" },
    }

    componentDidMount() {
        // $FlowExpectError
        this.M = require("materialize-css/dist/js/materialize.js")
        this.M.updateTextFields()
    }

    handleEmailChange = (e: SyntheticInputEvent<*>) =>
        this.setState({ fields: { email: e.target.value } })

    handleFormSubmit = () => {
        if (!this.state.fields.email) {
            return this.setState({
                submitted: false,
                errors: "Please enter your email address",
            })
        }

        const url = `/signup/newsletter?email=${this.state.fields.email}`
        const opts = { method: "POST" }

        return fetch(url, opts).then((res) => {
            if (res.ok) {
                return this.setState({ submitted: true, errors: null })
            } else {
                return this.setState({
                    submitted: false,
                    errors:
                        "Something went wrong. " +
                        "Please try again or contact us at support@simplyrets.com ",
                })
            }
        })
    }

    render() {
        return (
            <div className="row">
                <div className="col s10 offset-s1 center">
                    <h4 style={{ marginTop: 30 }}>Tune in</h4>
                    {this.state.submitted && !this.state.errors ? (
                        <p
                            style={{ marginBottom: 0, fontWeight: "bold" }}
                            className="center green-text">
                            Success! Thanks for signing up, we'll keep you in
                            the loop.
                        </p>
                    ) : (
                        <>
                            <p
                                className="grey-text text-darken-2"
                                style={{ marginBottom: 10 }}>
                                Don't want to miss an update? Sign up for the
                                SimplyRETS newsletter
                            </p>
                            <div className="input-field">
                                <input
                                    required
                                    name="email"
                                    type="email"
                                    value={this.state.fields.email}
                                    onChange={this.handleEmailChange}
                                    style={{ marginBottom: 15 }}
                                />
                                <label id="email" htmlFor="email">
                                    Email address
                                </label>
                                {this.state.errors && (
                                    <span className="helper-text red-text">
                                        {this.state.errors}
                                    </span>
                                )}
                            </div>
                            <div className="center">
                                <button
                                    onClick={this.handleFormSubmit}
                                    className="btn btn-flat blue white-text">
                                    Signup
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        )
    }
}

type Tag = {
    fieldValue: string,
    totalCount: number,
}

const Tags = () => {
    const {
        allMarkdownRemark: { tagsGroup },
    } = useStaticQuery(graphql`
        query TagsQuery {
            allMarkdownRemark {
                tagsGroup: group(field: frontmatter___tags) {
                    fieldValue
                    totalCount
                }
            }
        }
    `)

    if (!tagsGroup.length) return null

    return (
        <div className="row">
            <div className="col s12 center">
                <h4>Tags</h4>
                <p style={{ marginBottom: 0 }}>
                    {tagsGroup.map((tag: Tag, idx: number) => (
                        <TagItem
                            key={tag.fieldValue}
                            tag={tag}
                            last={idx === tagsGroup.length - 1}
                        />
                    ))}
                </p>
            </div>
        </div>
    )
}

const TagItem = ({ tag, last }: { tag: Tag, last: boolean }) => (
    <Link to={`/tags/${encodeURIComponent(tag.fieldValue)}`}>
        {tag.fieldValue} <small>({tag.totalCount})</small>
        {last ? "" : ", "}
    </Link>
)

const Signup = () => (
    <div className="row">
        <div className="col s12 center">
            <h4>Join SimplyRETS</h4>
            <p style={{ maxWidth: "90%", margin: "0 auto 25px" }}>
                Create an account and get started with the API
            </p>
            <A href="/signup" className="btn btn-flat btn-sm blue white-text">
                Sign up!
            </A>
        </div>
    </div>
)

const Social = () => (
    <div className="row">
        <div className="col s12 center">
            <h4>On the web</h4>
            <p style={{ marginBottom: 25 }}>
                <Link
                    className="grey-text"
                    to="/rss.xml"
                    style={{ marginRight: 20 }}>
                    <i className="fa fa-rss fa-3x" />
                </Link>{" "}
                <A
                    outbound
                    className="grey-text"
                    href="https://github.com/SimplyRETS"
                    style={{ marginRight: 20 }}>
                    <i className="fa fa-github fa-3x" />
                </A>{" "}
                <A
                    outbound
                    className="grey-text"
                    href="https://twitter.com/SimplyRETS">
                    <i className="fa fa-twitter fa-3x" />
                </A>
            </p>
        </div>
    </div>
)
